import type { DataLayer } from '../DataLayer';
import { filterBlanks } from '../utils/filterBlanks';

export const isSeekDomain =
  /(?:^\/[^\/])|(?:^[\.#])|(?:seek\.(com\.au|co\.nz))/i;

export type PageName =
  | 'home'
  | 'search results'
  | 'job details'
  | 'profile'
  | 'saved search'
  | 'recommended jobs'
  | 'onboarding';

export interface LinkContext {
  linkAction?: string;
  linkPosition?: string;
  linkSection?: string;
  linkText?: string;
}
export interface CurrentPageOptions {
  currentPage?: PageName;
  customCurrentPage?: string;
}

export interface LinkClickedLinkContext
  extends LinkContext,
    CurrentPageOptions {
  jobId?: string;
}

export interface NavigationPressedProps
  extends LinkContext,
    CurrentPageOptions {}

export type LinkPayload = {
  href: string;
  linkContext?: LinkClickedLinkContext;
  linkName: string;
  experimentFlightId?: string;
  trackingCorrelationId?: string;
};

export const mapLinkContext = ({
  currentPage,
  customCurrentPage,
  jobId,
  linkAction,
  linkPosition,
  linkSection,
  linkText,
}: LinkClickedLinkContext) => ({
  ...(customCurrentPage || currentPage
    ? { currentPage: customCurrentPage || currentPage }
    : {}),
  ...(jobId ? { jobId } : {}),
  ...(linkAction ? { linkAction } : {}),
  ...(linkPosition ? { linkPosition } : {}),
  ...(linkText ? { linkText } : {}),
  ...(linkSection ? { linkSection } : {}),
});

const linkNameWithoutIsExitLinkField = [
  'accordion_pressed',
  'job_apply_pressed',
  'jobs_by_company_pressed',
  'company_profile_pressed',
  'company_reviews_pressed',
  'lmis_pressed',
];

export const mapLinkType = (
  { linkName, href }: LinkPayload = {
    linkName: '',
    href: '',
  },
): DataLayer =>
  filterBlanks({
    linkName,
    ...(!Boolean(
      linkNameWithoutIsExitLinkField.find((l) => l === linkName),
    ) && {
      isExitLink: !isSeekDomain.test(href),
    }),
  });
